import React from "react";
import "../../css/Footer_New.css";
import "../../css/Footer_Modern.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaYoutube, FaShieldAlt, FaFileContract, FaRegCopyright, FaHandshake, FaCheckCircle } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { address, email, phone } from "../../constants";

const Footer = () => {
  return (
    <footer className="footer_new_wrapper">
      {/* Background Kinetic Grid + Watermark */}
      <div className="footer_bg_grid"></div>
      <div className="footer_watermark">ACTO</div>

      <div className="footer_container">

        <motion.div
          className="footer_main_deck"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* Column 1: Brand Info */}
          <div className="footer_brand">
            <Link to="/">
              <motion.img
                src={process.env.PUBLIC_URL + "/images/logo-dark.svg"}
                alt="ActoLoan Logo"
                className="footer_logo_img"
                width="850"
                height="200"
                whileHover={{ scale: 1.05 }}
              />
            </Link>
            <p className="footer_brand_desc">
              Powering the future of liquidity with architectural precision. ActoLoan delivers high-speed capital solutions for the modern digital economy.
            </p>
            <div className="footer_social_row">
              <motion.a href="https://www.instagram.com/actoloan_/" target="_blank" rel="noopener noreferrer" className="social_pill" whileHover={{ y: -10 }}><FaInstagram /></motion.a>
              <motion.a href="https://www.facebook.com/Actoloan/" target="_blank" rel="noopener noreferrer" className="social_pill" whileHover={{ y: -10 }}><FaFacebookF /></motion.a>
              <motion.a href="https://www.youtube.com/@Actoloan-official" target="_blank" rel="noopener noreferrer" className="social_pill" whileHover={{ y: -10 }}><FaYoutube /></motion.a>
              <motion.a href="https://x.com/actoloan" target="_blank" rel="noopener noreferrer" className="social_pill" whileHover={{ y: -10 }}><FaXTwitter /></motion.a>
              <motion.a href="https://www.linkedin.com/in/acto-loan-3829993b5/" target="_blank" rel="noopener noreferrer" className="social_pill" whileHover={{ y: -10 }}><FaLinkedinIn /></motion.a>
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div className="footer_col">
            <h4>Quick Links</h4>
            <ul className="footer_links">
              <li><Link to="/home">System Dashboard</Link></li>
              <li><Link to="/about-ActoLoan">About Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/ActoLoan-Services">Loan Solution</Link></li>
              <li><Link to="/apply-now">Initiate Loan</Link></li>
              <li><Link to="/repayloan">Repayment Portal</Link></li>
              <li><Link to="/rateandterms">Rate And Terms</Link></li>
              <li><Link to="/fairpracticecode">Fair Practice Code</Link></li>
              <li><Link to="/grievances">Grievances</Link></li>
              <li><Link to="/deletion-policy">Deletion Policy</Link></li>
              <li><Link to="/return-and-cancellation-policy">Return & Cancellation Policy</Link></li>
            </ul>
          </div>

          {/* Column 3: Regional Hubs */}
          <div className="footer_col">
            <Link to="/regional-hubs" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h4 className="footer_hub_heading">
                Explore Locations
                <span style={{
                  fontSize: '11px',
                  background: '#0ea5e9',
                  color: '#fff',
                  padding: '3px 10px',
                  borderRadius: '12px',
                  letterSpacing: '1px',
                  fontWeight: '800',
                  boxShadow: '0 2px 5px rgba(14, 165, 233, 0.4)'
                }}>VIEW MAP</span>
              </h4>
            </Link>
            <ul className="footer_links">
              <li><Link to="/Apply-for-personal-loan-in-New-Delhi">New Delhi</Link></li>
              <li><Link to="/Apply-for-instant-cash-loan-in-Bangalore">Bangalore</Link></li>
              <li><Link to="/Apply-for-instant-personal-loan-in-Mumbai">Mumbai</Link></li>
              <li><Link to="/Apply-for-personal-loan-in-ahmedabad">Ahmedabad</Link></li>
              <li><Link to="/instant-personal-loan-online-in-hyderabad">Hyderabad</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Nodes */}
          <div className="footer_col">
            <h4>Contact Us</h4>
            <motion.div className="contact_node" whileHover={{ x: 10 }}>
              <div className="cn_icon"><FaPhoneAlt /></div>
              <div className="cn_info">
                <span>Central Line</span>
                <strong>{phone}</strong>
              </div>
            </motion.div>
            <motion.div className="contact_node" whileHover={{ x: 10 }}>
              <div className="cn_icon"><FaEnvelope /></div>
              <div className="cn_info">
                <span>Support Desk</span>
                <strong>{email}</strong>
              </div>
            </motion.div>
            <motion.div className="contact_node address_node" whileHover={{ x: 10 }}>
              <div className="cn_icon"><FaMapMarkerAlt /></div>
              <div className="cn_info">
                <span style={{ textTransform: 'uppercase' }}>Registered Address</span>
                <strong className="compact_address">{address}</strong>
              </div>
            </motion.div>

            {/* Ultra-Modern Minimalist Lending Partner Card */}
            <motion.div 
              className="partner_card"
              whileHover={{ y: -5, boxShadow: '0 20px 40px rgba(0,0,0,0.06)' }}
            >
              {/* Elegant Side Accent */}
              <div className="partner_side_accent"></div>

              <div className="partner_body">
                <div className="partner_icon">
                  <FaHandshake />
                </div>
                
                <div className="partner_info">
                  <span className="partner_tagline">
                    ActoLoan Lending Partner
                  </span>
                  <strong className="partner_name">
                    Prakash Chemtex (India) Pvt Ltd.
                  </strong>
                  
                  <div className="partner_meta">
                    <span className="partner_reg">
                      Reg: 1400538
                    </span>
                    <div className="partner_badge">
                      <FaCheckCircle style={{ color: '#10b981', fontSize: '12px' }} />
                      <span className="partner_badge_text">RBI REG NBFC</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

        </motion.div>

        {/* Large Kinetic Brand Base */}
        <motion.div
          className="footer_kinetic_base"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}>
          ACTOLOAN
        </motion.div>

      </div>

      {/* Bottom Kinetic Strip */}
      <div className="footer_strip">
        <div className="strip_content">
          <p className="copyright_v3">
            <FaRegCopyright className="icon_neon" />
            <span>2026 <strong>Prakash Chemtex (India) Pvt Ltd.</strong> All Rights Reserved.</span>
          </p>
          <div className="legal_row_v3">
            <Link to="/privacypolicy">
              <FaShieldAlt className="icon_neon" style={{ fontSize: '12px' }} /> Privacy
            </Link>
            <Link to="/termsandconditions">
              <FaFileContract className="icon_neon" style={{ fontSize: '12px' }} /> Terms
            </Link>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
